<div class="req-content">

  <div class="table-container mat-elevation-z8" style="height: 100%; overflow-y: auto;">

    <table class="table table-striped border_bottom table-hover table-sm">
      <thead>
        <tr>
          <th scope="col" class="border-top-0">Fecha</th>
          <th scope="col" class="border-top-0">Usuario</th>
          <th scope="col" class="border-top-0">Acción</th>
          <th scope="col" class="border-top-0">Duración</th>
        </tr>
      </thead>
      <tbody>
        @for (row of pagedHistorials; track row; let i = $index) {
          <tr data-toggle="collapse" data-target=".order1">
            <td class="col-date">{{ formatLogDate(row.date) }}</td>
            <td>{{ row.user || 'Sistema' }}</td>
            <td>
              @if (getTypeOfHistorial(row) === 'file') {
                <p>
                  <a href="{{ row.url }}" target="_blank">{{ row.filename | truncate:8}}</a>
                </p>
              }
              @if (getTypeOfHistorial(row) === 'editedOnline') {
                <p class="historial-doc-action">
                  Documento editado online:
                  @if (row.url) {
                    <a class="historial-doc-name" href="{{ row.url }}" target="_blank" [title]="row.filename">{{ row.filename }}</a>
                  } @else {
                    <b class="historial-doc-name" [title]="row.filename">{{ row.filename }}</b>
                  }
                </p>
              }
              @if (getTypeOfHistorial(row) === 'note') {
                <p>
                  <b>Nota: </b> {{ row.note }}
                </p>
              }
              @if (getTypeOfHistorial(row) === 'assigned') {
                <p>
                  Asignado a <b>{{ row.assigneduser }}</b>
                </p>
              }
              @if (getTypeOfHistorial(row) === 'status') {
                <p>
                  Estado cambiado desde <b>{{ row.status1 }}</b> a <b>{{ row.status2 }}</b>
                </p>
              }
              @if (getTypeOfHistorial(row) === 'created') {
                <p>
                  Creación del requerimiento
                </p>
              }
              @if (getTypeOfHistorial(row) === 'fieldsupdated') {
                <p>
                  Actualización del requerimiento {{row.fieldsupdated}}
                </p>
              }
              @if (getTypeOfHistorial(row) === 'undefined') {
                <p>
                  Sin Descripción
                </p>
              }
            </td>
            <td>
              @if (row.value && row.value.length) {
                <i class="fas fa-info-circle"
                  ngbPopover="{{row.value[0]}}: {{row.value[1]}}" placement="start"
                popoverTitle="Detalle de la devolución: "></i>
              }
              @if (row.duration && row.duration.length>1) {
                <span>
                {{row.duration[1]}}</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (pagination) {
      <div class="row">
        <div class="col-md-6 justify-content-start ">
          <select class="custom-select custom-select-pagination" style="width: auto"
            [(ngModel)]="pagination.per_page" (ngModelChange)="refreshCountries()">
            <option [ngValue]="5">Ver 5</option>
            <option [ngValue]="10">Ver 10 </option>
            <option [ngValue]="20">Ver 20</option>
            <option [ngValue]="50">Ver 50 </option>
          </select>
        </div>
        <div class="col-md-6 pt-1 justify-content-end">
          <span>Total: {{ pagination.total }}</span>
        </div>
        <div class="col-md-12 mt-2">
          <nav aria-label="Page navigation">
            <div
              class="pagination justify-content-center pagination-separate pagination-curved pagination-flat">
              <ngb-pagination [collectionSize]="pagination.total" [(page)]="pagination.current_page"
                [boundaryLinks]="true" [pageSize]="pagination.per_page" (pageChange)="pageChanged($event)"
                aria-label="Default pagination">
                <ng-template ngbPaginationFirst><i class="inp-btn-p inp-icon-chevrons-left-o"></i>
              </ng-template>
              <ng-template ngbPaginationLast><i class="inp-btn-p inp-icon-chevrons-right-o"></i>
            </ng-template>
            <ng-template ngbPaginationPrevious><i class="inp-btn-p inp-icon-chevron-left-o"></i>
          </ng-template>
          <ng-template ngbPaginationNext><i class="inp-btn-p inp-icon-chevron-right-o"></i>
        </ng-template>
        <ng-template ngbPaginationEllipsis>...</ng-template>
        <ng-template ngbPaginationNumber let-page class="round">{{ page }}</ng-template>
      </ngb-pagination>
    </div>
  </nav>
</div>
</div>
}

</div>
</div>
